module.exports = __webpack_public_path__ + "static/media/howtobefat_img_2.c1fd781c.png";